import api from '@/api'
import agreements from '@/api/apiSferest/services/agreements'

export const getList = ({ commit, state, getters }) => {
  return new Promise((resolve, reject) => {
    let params = {}
    agreements.list(params)
    .then((res) => {
      commit('list/SET_LIST', res.data)
      resolve(res.data)
    })
  })
}

export const getMore = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.apiSferest.get(state.search.more, { data: {} })
    .then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      commit('list/ADD_TO_LIST', res.data)
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_EXPEDIENT', '')
    commit('SET_DESCRIPTION', '')
    commit('SET_AMOUNT', '')
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}
